import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CircularRequestComponent } from 'src/app/front-user/services/Circulars/circular-request/circular-request.component';
import { CircularsCancelRequestComponent } from 'src/app/front-user/services/Circulars/circulars-cancel-request/circulars-cancel-request.component';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ErrorsEnum, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CircularService } from 'src/app/shared/services/circular.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
//import { threadId } from 'worker_threads';

@Component({
  selector: 'app-circulars-confirm-cancel',
  templateUrl: './circulars-confirm-cancel.component.html',
  styleUrls: ['./circulars-confirm-cancel.component.css']
})
export class CircularsConfirmCancelComponent implements OnInit {
  //#region Properties & Variables
  @ViewChild('circularsCancelRequest',{static: false}) circularsCancelRequest: CircularsCancelRequestComponent;
  public isRequestSucceeded: boolean = false;
  public showSubmit: boolean;
  private ResponseObject: ResponseObject = new ResponseObject();
  public currentUser: User = new User();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion
  constructor(private circularsService: CircularService, public datepipe: DatePipe, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
  }
  onCancelRequestLoadedFlag(flag: boolean) {
    if (flag) {
      if (this.circularsCancelRequest.circularsRequest.rebateRequestLoaded.InternalStatusId == ServiceStatus.Circulars_ClosedCancelled) {
        this.showSubmit = false;
      } else if (this.circularsCancelRequest.circularsRequest.rebateRequestLoaded.InternalStatusId == ServiceStatus.Circulars_CanceledByRequestor) {
        this.showSubmit = true;
      }
      this.circularsCancelRequest.circularsRequest.insideCancelationComponents = true;
      this.circularsCancelRequest.isShow = false;
    }
  }

  submit(): void {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
    this.circularsCancelRequest.circularsRequest.rebateRequestLoaded.ModifiedBy = this.currentUser.Email;
    this.submitConfirmCancel();
  }
  submitConfirmCancel(): void {
    this.circularsService.confirmCancelRequest(this.circularsCancelRequest.circularsRequest.rebateRequestLoaded).subscribe(
      data => this.ResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitCancelCompleted()
    );
  }
  submitCancelCompleted(): void {
    if (!this.ResponseObject.Success) {
      //Enable Error / Warning
      if (this.ResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if (this.ResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
    this.isRequestSucceeded = true;
  }
}

enum ConfirmationMode {
Success = 1,
Warning = 2,
Error = 3
}
